import React from 'react'

const CrossIcon = ({ color = '#ff1010', className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 11.268 11.268">
    <path
      d="m10.937 1.923-3.71 3.71 3.71 3.71a1.127 1.127 0 1 1-1.593 1.593l-3.71-3.711-3.71 3.71A1.127 1.127 0 1 1 .33 9.344l3.711-3.71L.33 1.923A1.127 1.127 0 1 1 1.923.33l3.71 3.711 3.71-3.71a1.127 1.127 0 1 1 1.593 1.593z"
      style={{ fill: color }}
    />
  </svg>
)

export default CrossIcon
